import { useState, useEffect } from 'react';
import api from '../services/api';
import JobProgress from '../components/JobProgress';

const TIPOS = [
  { value: 'promo',   label: 'Promoción' },
  { value: 'puntos',  label: 'Actualización de puntos' },
  { value: 'evento',  label: 'Evento especial' },
  { value: 'general', label: 'Mensaje general' },
];

const SEGMENTOS = [
  { value: 'todos',    label: 'Todos los clientes' },
  { value: 'gold',     label: 'Nivel Gold' },
  { value: 'silver',   label: 'Nivel Silver' },
  { value: 'standard', label: 'Nivel Standard' },
];

const TABS = ['Enviar ahora', 'Programadas', 'Cumpleaños'];

export default function Notificaciones() {
  const [tab, setTab]         = useState(0);
  const [form, setForm]       = useState({ tipo:'promo', segmento:'todos', titulo:'', mensaje:'', url:'https://2cap.com.mx/' });
  const [campForm, setCampForm] = useState({ segmento:'todos', titulo:'', mensaje:'', url:'https://2cap.com.mx/', scheduled_at:'' });
  const [bdayForm, setBdayForm] = useState({ titulo:'', mensaje:'' });
  const [loading, setLoading] = useState(false);
  const [campLoading, setCampLoading] = useState(false);
  const [result, setResult]   = useState(null);
  const [stats, setStats]     = useState(null);
  const [history, setHistory] = useState([]);
  const [scheduled, setScheduled] = useState([]);
  const [activeJobId, setActiveJobId] = useState(null); // job en progreso para el modal

  useEffect(() => {
    api.get('/api/notifications/stats').then(r => setStats(r.data.data)).catch(() => {});
    api.get('/api/notifications/history').then(r => setHistory(r.data.data || [])).catch(() => {});
    api.get('/api/scheduled-notifications').then(r => setScheduled(r.data.data || [])).catch(() => {});
    // Cargar config de cumpleaños
    api.get('/api/pass-design').then(r => {
      if (r.data.success) {
        const d = r.data.data;
        setBdayForm({
          titulo:  d.birthday_titulo  || '¡Feliz cumpleaños! 🎂',
          mensaje: d.birthday_mensaje || 'En tu día especial tienes un regalo esperándote. ¡Visítanos!'
        });
      }
    }).catch(() => {});
  }, []);

  // ─── Enviar ahora ─────────────────────────────────────────────
  const send = async (e) => {
    e.preventDefault();
    setLoading(true); setResult(null);
    try {
      const mensajePass = form.titulo ? `${form.titulo}: ${form.mensaje}` : form.mensaje;

      // El endpoint /notifications/send ahora encola un job y devuelve job_id inmediato
      const passRes = await api.post('/api/notifications/send', {
        tipo: form.tipo, segmento: form.segmento, titulo: form.titulo, mensaje: mensajePass,
      });

      // Abrir modal de progreso con el job_id
      if (passRes.data.job_id) {
        setActiveJobId(passRes.data.job_id);
      }

      // Web push se mantiene síncrono (es rápido)
      const webPushRes = await api.post('/api/web-push/send', {
        segmento: form.segmento, titulo: form.titulo, mensaje: form.mensaje, url: form.url,
      }).catch(() => ({ data: { sent: 0 } }));

      setResult({
        ok: true,
        msg: 'Notificación encolada — sigue el progreso en el modal.',
        stats: { android_sent: webPushRes.data.sent || 0 },
      });
      setForm(prev => ({ ...prev, titulo: '', mensaje: '' }));
    } catch (err) {
      setResult({ ok: false, msg: err.response?.data?.message || 'Error al enviar' });
    } finally {
      setLoading(false);
    }
  };

  // ─── Cuando termina el job → refrescar historial ──────────────
  const handleJobDone = (job) => {
    api.get('/api/notifications/history').then(r => setHistory(r.data.data || [])).catch(() => {});
    if (job.status === 'done' && job.result_summary) {
      const s = job.result_summary;
      setResult({
        ok: true,
        msg: `Notificación enviada: ${s.ok || 0} de ${s.total || 0} exitosos`,
        stats: { ...s, android_sent: result?.stats?.android_sent || 0 },
      });
    }
  };

  // ─── Programar campaña ────────────────────────────────────────
  const scheduleCampaign = async (e) => {
    e.preventDefault();
    setCampLoading(true);
    try {
      await api.post('/api/scheduled-notifications', { ...campForm, tipo: 'campaign' });
      setCampForm({ segmento:'todos', titulo:'', mensaje:'', url:'https://2cap.com.mx/', scheduled_at:'' });
      const r = await api.get('/api/scheduled-notifications');
      setScheduled(r.data.data || []);
      alert('Campaña programada correctamente ✅');
    } catch (err) {
      alert(err.response?.data?.message || 'Error programando campaña');
    } finally { setCampLoading(false); }
  };

  // ─── Cancelar programada ──────────────────────────────────────
  const cancelScheduled = async (id) => {
    if (!confirm('¿Cancelar esta notificación?')) return;
    await api.delete(`/api/scheduled-notifications/${id}`);
    const r = await api.get('/api/scheduled-notifications');
    setScheduled(r.data.data || []);
  };

  // ─── Guardar config cumpleaños ────────────────────────────────
  const saveBirthday = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/pass-design', { birthday_titulo: bdayForm.titulo, birthday_mensaje: bdayForm.mensaje });
      alert('Mensaje de cumpleaños guardado ✅');
    } catch { alert('Error guardando'); }
  };

  const fmt = iso => iso ? new Date(iso).toLocaleString('es-MX', { dateStyle:'short', timeStyle:'short' }) : '—';
  const fmtDate = iso => iso ? new Date(iso).toLocaleString('es-MX', { dateStyle:'medium', timeStyle:'short' }) : '—';

  return (
    <div>
      <div style={s.header}>
        <h1 style={s.title}>Notificaciones Push</h1>
        <p style={s.sub}>Envía y programa mensajes para tus clientes</p>
      </div>

      {/* Stats */}
      {stats && (
        <div style={s.statsRow}>
          {[['Clientes activos', stats.total_customers], ['Passes Apple', stats.apple_passes], ['Passes Google', stats.google_passes]].map(([label, val]) => (
            <div key={label} style={s.statCard}>
              <div style={s.statVal}>{val}</div>
              <div style={s.statLabel}>{label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Tabs */}
      <div style={s.tabs}>
        {TABS.map((t, i) => (
          <button key={t} style={{ ...s.tab, ...(tab === i ? s.tabActive : {}) }} onClick={() => setTab(i)}>{t}</button>
        ))}
      </div>

      {/* ─── TAB: Enviar ahora ─── */}
      {tab === 0 && (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24, marginTop:24 }}>
          <div style={s.card}>
            <div style={s.cardHead}>Nueva notificación</div>
            {result && (
              <div style={{ ...s.alert, background:result.ok?'#f0fdf4':'#fff0f0', borderLeftColor:result.ok?'#16a34a':'#dc1414', color:result.ok?'#166534':'#b91c1c' }}>
                {result.msg}
                {result.ok && result.stats && (
                  <div style={{ fontSize:11, marginTop:6, opacity:0.8 }}>
                    <div>🍎 Apple: push enviados</div>
                    <div>🤖 Android Wallet: actualizados</div>
                    <div>📱 Android Chrome: {result.stats.android_sent} notificaciones</div>
                  </div>
                )}
              </div>
            )}
            <form onSubmit={send}>
              <div style={s.field}><label style={s.label}>Tipo</label>
                <select style={s.input} value={form.tipo} onChange={e => setForm({...form, tipo:e.target.value})}>
                  {TIPOS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
              <div style={s.field}><label style={s.label}>Destinatarios</label>
                <select style={s.input} value={form.segmento} onChange={e => setForm({...form, segmento:e.target.value})}>
                  {SEGMENTOS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
              <div style={s.field}><label style={s.label}>Título <span style={{color:'#dc1414'}}>*</span></label>
                <input style={s.input} required maxLength={60} value={form.titulo} placeholder="ej. ¡Oferta especial!" onChange={e => setForm({...form, titulo:e.target.value})} />
                <span style={s.hint}>{form.titulo.length}/60</span>
              </div>
              <div style={s.field}><label style={s.label}>Mensaje <span style={{color:'#dc1414'}}>*</span></label>
                <textarea style={{...s.input, height:80, resize:'vertical'}} required maxLength={140} value={form.mensaje} placeholder="20% de descuento este fin de semana..." onChange={e => setForm({...form, mensaje:e.target.value})} />
                <span style={s.hint}>{form.mensaje.length}/140 · En iPhone aparecerá: "{form.titulo ? form.titulo+': ' : ''}{form.mensaje.substring(0,40)}{form.mensaje.length>40?'...':''}"</span>
              </div>
              <div style={s.field}><label style={s.label}>URL al tocar (Android)</label>
                <input style={s.input} value={form.url} onChange={e => setForm({...form, url:e.target.value})} />
              </div>
              <div style={s.channelsBox}>
                {[['🍎','Apple Wallet','Pantalla de bloqueo iPhone'],['🤖','Google Wallet','Actualización silenciosa Android'],['📱','Android Chrome','Notificación push en pantalla']].map(([icon,name,desc]) => (
                  <div key={name} style={s.channelItem}><span>{icon}</span><div><div style={s.channelName}>{name}</div><div style={s.channelDesc}>{desc}</div></div></div>
                ))}
              </div>
              <button type="submit" style={s.btnPrimary} disabled={loading}>{loading ? 'Enviando...' : 'Enviar notificación'}</button>
            </form>
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div style={s.card}>
              <div style={s.cardHead}>Vista previa iPhone</div>
              <div style={s.previewWrap}>
                <div style={s.previewPhone}>
                  <div style={s.previewNotif}>
                    <div style={s.previewApp}>2CAP Loyalty · ahora</div>
                    <div style={s.previewTitle}>{form.titulo || 'Título de la notificación'}</div>
                    <div style={s.previewMsg}>{form.mensaje || 'Aquí aparecerá tu mensaje...'}</div>
                  </div>
                </div>
              </div>
            </div>
            <div style={s.card}>
              <div style={s.cardHead}>Historial reciente</div>
              {history.length === 0 ? <p style={{color:'#bbb',fontSize:13,textAlign:'center',padding:'20px 0'}}>Sin notificaciones enviadas</p>
              : history.slice(0,6).map(h => (
                <div key={h.id} style={s.histRow}>
                  <div><div style={{fontSize:13,fontWeight:600,color:'#111'}}>{h.title}</div><div style={{fontSize:11,color:'#aaa',marginTop:2}}>{h.body?.substring(0,50)}</div></div>
                  <div style={{textAlign:'right',flexShrink:0}}><div style={{fontSize:11,color:'#888'}}>{fmt(h.sent_at)}</div><span style={{...s.badge,background:'#f0fdf4',color:'#166534'}}>{h.status}</span></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ─── TAB: Programadas ─── */}
      {tab === 1 && (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24, marginTop:24 }}>
          <div style={s.card}>
            <div style={s.cardHead}>Nueva campaña programada</div>
            <form onSubmit={scheduleCampaign}>
              <div style={s.field}><label style={s.label}>Destinatarios</label>
                <select style={s.input} value={campForm.segmento} onChange={e => setCampForm({...campForm, segmento:e.target.value})}>
                  {SEGMENTOS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                </select>
              </div>
              <div style={s.field}><label style={s.label}>Título <span style={{color:'#dc1414'}}>*</span></label>
                <input style={s.input} required maxLength={60} value={campForm.titulo} placeholder="ej. ¡Feliz Navidad! 🎄" onChange={e => setCampForm({...campForm, titulo:e.target.value})} />
              </div>
              <div style={s.field}><label style={s.label}>Mensaje <span style={{color:'#dc1414'}}>*</span></label>
                <textarea style={{...s.input, height:80, resize:'vertical'}} required maxLength={140} value={campForm.mensaje} placeholder="Mensaje de la campaña..." onChange={e => setCampForm({...campForm, mensaje:e.target.value})} />
              </div>
              <div style={s.field}><label style={s.label}>URL al tocar</label>
                <input style={s.input} value={campForm.url} onChange={e => setCampForm({...campForm, url:e.target.value})} />
              </div>
              <div style={s.field}><label style={s.label}>Fecha y hora de envío <span style={{color:'#dc1414'}}>*</span></label>
                <input style={s.input} type="datetime-local" required value={campForm.scheduled_at} onChange={e => setCampForm({...campForm, scheduled_at:e.target.value})} />
                <span style={s.hint}>Se enviará a las 11am del día seleccionado</span>
              </div>
              <button type="submit" style={s.btnPrimary} disabled={campLoading}>{campLoading ? 'Programando...' : 'Programar campaña'}</button>
            </form>
          </div>

          <div style={s.card}>
            <div style={s.cardHead}>Campañas programadas</div>
            {scheduled.filter(n => n.tipo === 'campaign').length === 0
              ? <p style={{color:'#bbb',fontSize:13,textAlign:'center',padding:'20px 0'}}>Sin campañas programadas</p>
              : scheduled.filter(n => n.tipo === 'campaign').map(n => (
                <div key={n.id} style={s.histRow}>
                  <div>
                    <div style={{fontSize:13,fontWeight:600,color:'#111'}}>{n.titulo}</div>
                    <div style={{fontSize:11,color:'#aaa',marginTop:2}}>{n.mensaje?.substring(0,50)}</div>
                    <div style={{fontSize:11,color:'#888',marginTop:2}}>📅 {fmtDate(n.scheduled_at)} · {n.segmento}</div>
                  </div>
                  <div style={{textAlign:'right',flexShrink:0}}>
                    <span style={{...s.badge, background:n.status==='pending'?'#fff8e1':n.status==='sent'?'#f0fdf4':'#fff0f0', color:n.status==='pending'?'#b45309':n.status==='sent'?'#166534':'#b91c1c'}}>{n.status}</span>
                    {n.status === 'pending' && <button onClick={() => cancelScheduled(n.id)} style={{...s.btnDanger, marginTop:6, display:'block'}}>Cancelar</button>}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}

      {/* ─── TAB: Cumpleaños ─── */}
      {tab === 2 && (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24, marginTop:24 }}>
          <div style={s.card}>
            <div style={s.cardHead}>Mensaje de cumpleaños automático</div>
            <div style={s.infoBox}>
              🤖 Este mensaje se envía automáticamente cada día a las 11am a los clientes que cumplen años ese día. Usa <code style={{background:'#f0f0f0',padding:'1px 4px'}}>{'{nombre}'}</code> para personalizar con el nombre del cliente.
            </div>
            <form onSubmit={saveBirthday} style={{marginTop:16}}>
              <div style={s.field}><label style={s.label}>Título</label>
                <input style={s.input} value={bdayForm.titulo} maxLength={60}
                  placeholder="¡Feliz cumpleaños! 🎂"
                  onChange={e => setBdayForm({...bdayForm, titulo:e.target.value})} />
              </div>
              <div style={s.field}><label style={s.label}>Mensaje</label>
                <textarea style={{...s.input, height:100, resize:'vertical'}} value={bdayForm.mensaje} maxLength={200}
                  placeholder="Hola {nombre}, en tu día especial tienes un regalo esperándote..."
                  onChange={e => setBdayForm({...bdayForm, mensaje:e.target.value})} />
                <span style={s.hint}>Usa {'{nombre}'} para incluir el nombre del cliente</span>
              </div>
              <button type="submit" style={s.btnPrimary}>Guardar mensaje de cumpleaños</button>
            </form>
          </div>

          <div style={s.card}>
            <div style={s.cardHead}>Vista previa</div>
            <div style={s.previewWrap}>
              <div style={s.previewPhone}>
                <div style={s.previewNotif}>
                  <div style={s.previewApp}>2CAP Loyalty · 11:00 am</div>
                  <div style={s.previewTitle}>{bdayForm.titulo || '¡Feliz cumpleaños! 🎂'}</div>
                  <div style={s.previewMsg}>{(bdayForm.mensaje || '').replace('{nombre}', 'Fernando')}</div>
                </div>
              </div>
            </div>
            <div style={{...s.infoBox, marginTop:16}}>
              El cron job corre diariamente a las 11am y envía automáticamente a todos los clientes que cumplan años ese día.
            </div>
          </div>
        </div>
      )}

      {/* Modal de progreso para jobs en background */}
      <JobProgress
        jobId={activeJobId}
        title="Enviando notificaciones"
        onClose={() => setActiveJobId(null)}
        onDone={handleJobDone}
      />
    </div>
  );
}

const s = {
  header: { marginBottom:20 },
  title: { fontSize:24, fontWeight:700, margin:'0 0 4px', color:'#111', fontFamily:"'Barlow Condensed',sans-serif", textTransform:'uppercase', letterSpacing:-0.5 },
  sub: { fontSize:13, color:'#888', margin:0 },
  statsRow: { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16, marginBottom:0 },
  statCard: { background:'#fff', border:'1px solid #eee', padding:'16px 20px' },
  statVal: { fontSize:28, fontWeight:700, color:'#111', fontFamily:"'Barlow Condensed',sans-serif" },
  statLabel: { fontSize:11, color:'#888', letterSpacing:1, textTransform:'uppercase', marginTop:2 },
  tabs: { display:'flex', gap:0, borderBottom:'2px solid #eee', marginTop:24 },
  tab: { padding:'10px 24px', background:'none', border:'none', fontSize:13, fontWeight:600, color:'#888', cursor:'pointer', borderBottom:'2px solid transparent', marginBottom:-2, fontFamily:"'Barlow',sans-serif" },
  tabActive: { color:'#111', borderBottomColor:'#111' },
  card: { background:'#fff', border:'1px solid #eee', padding:24 },
  cardHead: { fontSize:11, fontWeight:600, letterSpacing:2.5, textTransform:'uppercase', color:'#aaa', marginBottom:18, paddingBottom:14, borderBottom:'1px solid #f5f5f5' },
  alert: { borderLeft:'3px solid', padding:'10px 14px', fontSize:13, marginBottom:16, fontWeight:500 },
  field: { marginBottom:16 },
  label: { display:'block', fontSize:11, fontWeight:600, letterSpacing:2, textTransform:'uppercase', color:'#555', marginBottom:6 },
  input: { width:'100%', padding:'10px 14px', border:'1.5px solid #e5e5e5', fontSize:14, outline:'none', boxSizing:'border-box', fontFamily:"'Barlow',sans-serif", borderRadius:0 },
  hint: { fontSize:11, color:'#bbb', display:'block', marginTop:4 },
  channelsBox: { background:'#fafafa', border:'1px solid #f0f0f0', padding:'12px 16px', marginBottom:16, display:'flex', flexDirection:'column', gap:8 },
  channelItem: { display:'flex', alignItems:'flex-start', gap:10, fontSize:13 },
  channelName: { fontWeight:600, color:'#333', fontSize:12 },
  channelDesc: { color:'#888', fontSize:11 },
  btnPrimary: { background:'#111', color:'#fff', border:'none', padding:'12px 24px', fontSize:12, fontWeight:600, letterSpacing:2, textTransform:'uppercase', cursor:'pointer', fontFamily:"'Barlow',sans-serif", marginTop:4 },
  btnDanger: { background:'#fff0f0', color:'#dc1414', border:'1px solid #fecaca', padding:'4px 10px', fontSize:11, fontWeight:600, cursor:'pointer', fontFamily:"'Barlow',sans-serif" },
  previewWrap: { display:'flex', justifyContent:'center', padding:'16px 0' },
  previewPhone: { background:'#1a1a1a', borderRadius:12, padding:14, width:240 },
  previewNotif: { background:'rgba(255,255,255,0.1)', borderRadius:8, padding:10 },
  previewApp: { fontSize:10, color:'rgba(255,255,255,0.4)', marginBottom:3, fontWeight:600, letterSpacing:1, textTransform:'uppercase' },
  previewTitle: { fontSize:13, fontWeight:700, color:'#fff', marginBottom:3 },
  previewMsg: { fontSize:12, color:'rgba(255,255,255,0.65)', lineHeight:1.4 },
  histRow: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', padding:'10px 0', borderBottom:'1px solid #f5f5f5', gap:12 },
  badge: { padding:'2px 8px', fontSize:10, fontWeight:600, textTransform:'uppercase', letterSpacing:0.5, display:'inline-block', marginTop:3 },
  infoBox: { background:'#fafafa', border:'1px solid #f0f0f0', padding:14, fontSize:12, color:'#666', lineHeight:1.6 },
};
